/* This is to keep all the API enpoints in one place . Here, You can add/update any API route and You can add/update any API endpoint
   You can use this endpoints anywhere in the application by importing the API object.
*/
const SSSUITE_API_BASE_URL = `${process.env.REACT_APP_SSSUITE_API_URL}api`;

// API routes
const USER_MANAGEMENT = "user-management";

// API endpoints
export const API = {
  // login and user
  USER_MANAGEMENT: {
    USER_DETAILS: `${SSSUITE_API_BASE_URL}/${USER_MANAGEMENT}/user-details`,
    RESET_USER_STATUS_CACHE: `${SSSUITE_API_BASE_URL}/${USER_MANAGEMENT}/reset-user-status-cache`,
    GET_USERS: `${SSSUITE_API_BASE_URL}/users`,
    UPDATE_LOGOUT_DATE :`${SSSUITE_API_BASE_URL}/api/login-history/update-logout-date`
  }
}




